export default __webpack_public_path__ + "static/Bun-7d76021adb0611fbcc08b17bab270903.svg";